<template>
    <div class="page bg-tc-blue-1 relative desktop-footer">
        <div class="bg-head-coin hidden sm:block"></div>
        <div class="page-content sm:px-8">
            <TopBar class="hidden sm:block" :modalController="modalController"></TopBar>
            <TopBarBack routeBack="/home" class="block sm:hidden"></TopBarBack>
            <MenuDesktop activeMenu="none"></MenuDesktop>
            <div class="mx-auto page mt-2 sm:pb-0 bg-a-gray-e9ecf5 sm:bg-tc-blue-1">
                <div class="h-2px bg-white sm:hidden"></div>
                <div class="sm:bg-white sm:px-5 sm:py-6 sm:mt-4 rounded-25" v-if="campaign != null">
                    <PathLink :campaignName="campaign.name" :isCampaignDeal="isCampaignDeal"></PathLink>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-0 sm:gap-5 sm:mt-4">
                        <div class="py-3 px-14px sm:p-0">
                            <Picture :campaign="campaign"></Picture>
                        </div>
                        <div class="px-14px">
                            <div class="bg-white p-5 mb-5 sm:p-0 rounded-t-25 ">
                                <DetailInfo :campaign="campaign" :isCampaignDeal="isCampaignDeal"></DetailInfo>
                                <div class="hidden sm:block my-5">
                                    <RedeemButton ref="redeemButton" 
                                        :detailController="detailController"
                                        :modalController="modalController"
                                        @clickRedeem="clickRedeem()"
                                    ></RedeemButton>
                                </div>
                                <div class="sm:hidden mb-28 min-h-50vh">
                                    <DetailAndCondition :campaign="campaign"></DetailAndCondition>
                                </div>
                                <div class="hidden sm:block">
                                    <DetailAndCondition :campaign="campaign"></DetailAndCondition>
                                </div>
                                 <div class="block sm:hidden footer-mobile-witdh fixed left-0 bottom-0 bg-white text-center pb-2 mx-14px px-14px rounded-b-25">
                                      <RedeemButton
                                            class="mt-5" ref="redeemButton"
                                            :detailController="detailController"
                                            :modalController="modalController"
                                            @clickRedeem="clickRedeem()"
                                        ></RedeemButton>
                                        <img class="logo-powerby m-auto pt-3" src="@/assets/logo/power-tip.png">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <BottomBar></BottomBar>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
//helper
import Util from '@/helper/Utility.js';
// import ConfigManager from '@/config/ConfigManager.js';
// import CacheHelper from '@/helper/CacheHelper.js';
//component
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import TopBarBack from '@/components/Layout/TopBar/TopBarBack.vue';
import DetailInfo from '../component/DetailInfo.vue';
import Picture from '../component/Picture.vue';
import DetailAndCondition from '../component/DetailAndCondition.vue';
import RedeemButton from '../component/RedeemButton.vue';
import MenuDesktop from '@/components/Layout/MenuDesktop/MenuDesktop.vue';
import BottomBar from '@/components/Layout/BottomBar/BottomBar.vue';
import PathLink from '../component/PathLink.vue';
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
//controller
import { DetailController } from '../controller/DetailController.js';
import { RedeemController } from '../controller/RedeemController.js';
//service
import { CampaignConfigBuilder } from '@/core/Campaign/model/CampaignConfigModel.js';
//store
import CampaignStore from '../store/CampaignStore';
import { CampaignType } from '@/helper/StaticValue'
export default {
    name: "Campaign",
    mixins: [ModalMixin, AuthStatusMixin],
    provide: {
        CampaignStore,
    },
    components: {
        TopBar,
        DetailInfo,
        Picture,
        DetailAndCondition,
        RedeemButton,
        MenuDesktop,
        BottomBar,
        PathLink,
        TopBarBack,
    },
    data: function() {
        return {
            isLoaded: false,
            //controller
            detailController: new DetailController(),
            redeemController: new RedeemController(),

            campaign: null,
        };
    },
    mounted: function(){
        this.initialIsFromLanding()
    },
    computed:{
        isCampaignDeal: function(){
            if(this.campaign.type == CampaignType.Deal){
                return true
            }
            return false
        }
    },
    methods: {
        //#region mixin
        /**
         * ฟังก์ชันนี้ถูกเรียก หลังจากตรวจสอบได้แล้วว่า login แล้วหรือยัง
         */
        onAccountInit: function() {
            this.initialCampaign();
        },
        /**
         * ฟังก์ชันนี้ถูกเรียก หลักจาก setup generic model เรียบร้อย
         */
        onSetupModalCompleted: function() {
            this.initialRedeemModal(); //ModalMixin
            this.initialAddressModal(); //ModalMixin
        },
        //#endregion mixin

        //#region initial
        initialCampaign: function () {
            var campaignId = this.$route.params.campaignId;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(campaignId)
                .create();

            this.setupDetailController();
        },

        /**
         * Function หลังจากหลับมาจากเว็บ Interface ให้ clear browser history
         */
        initialIsFromLanding: async function () {
            // var cacheHelper = new CacheHelper(ConfigManager.getCacheType());
            // var formLanding = Util.jsonParse(cacheHelper.getCache('isfromlanding'));

            // if (formLanding != null) {
            //     cacheHelper.removeCache('isfromlanding');

            //     if (formLanding.page == 'wodd') {
            //         return;
            //     }
            //     var backAmount = (formLanding.page == 'interface') ? -3 : -2;
            //     history.go(backAmount);
            // }
            this.AccountStore.methods.apiUpdatePoint().then(()=>{
                let backCount = this.$route.query.back;
                if (Util.isNumber(backCount) && backCount != 0) {
                    this.$router.go(backCount);
                }
            })
        },
        //#endregion initial

        //#region setup
        setupDetailController: function() {
            this.loadingModal.show();
            this.detailController.initial(this.campaignConfig).then((campaign) => {
                this.campaign = campaign;
                CampaignStore.methods.setCampaign(campaign);

                this.redeemController.initial(this.campaign, this.modalController);
                this.setRedeemEvent();
                this.onLoadedCampaign();
            }).catch((err) => {
                this.errorApi(err);
            }).finally(() => {
                this.loadingModal.hide();
            });
        },
        //#endregion setup

        //#region event
        refreshCampaignDetail: function() {
            this.loadingModal.show();
            this.detailController.reinitial().then((campaign) => {
                this.campaign = campaign;
                CampaignStore.methods.setCampaign(campaign);
                //console.log('refreshCampaignDetail', campaign);
                this.redeemController.initial(this.campaign, this.modalController);
                this.setRedeemEvent();
                this.onLoadedCampaign();
                
                // trigger update to btn redeem
                this.$refs['redeemButton'].reInitRedeemButton();

            }).catch((err) => {
                this.errorApi(err);
            }).finally(() => {
                this.loadingModal.hide();
            });
        },
        clickRedeem: function() {
            var selectCampaignId = this.detailController.selectedCampaignId;
            var selectedQuantity = this.detailController.selectedQuantity;
            this.redeemController.clickRedeem(selectCampaignId, selectedQuantity);
        },
        setRedeemEvent: function() {
            this.redeemController.onClickRedeem = () => {
                return true;
            };
            this.redeemController.onConfirmRedeem = () => {
                return true;
            };
            this.redeemController.onCancelRedeem = () => {
                return true;
            };
            this.redeemController.onOpenInterface = () => {
                return true;
            };
            this.redeemController.onOpenShipping = () => {
                return true;
            };
            this.redeemController.onSaveShipping = () => {
                return true;
            };
            this.redeemController.onRedeem = () => {
                this.loadingModal.show();
                return true;
            };
            this.redeemController.onRedeemSuccess = async () => {
                //account store for update point
                this.AccountStore.methods.apiUpdatePoint();
                this.loadingModal.hide();
                //console.log('onRedeemSuccess !!!!');
                // refresh campaign detail after redeem success
                this.refreshCampaignDetail();
                return true;
            };
            this.redeemController.onRedeemError = () => {
                this.loadingModal.hide();
                return true;
            };
            this.redeemController.onAddToCart = () => {
                this.loadingModal.show();
                return true;
            };
            this.redeemController.onAddToCartSuccess = (isClearCart) => { 
                console.log('onAddToCartSuccess isClearCart', isClearCart);
                if (isClearCart) { 
                    this.redeemController.openWebPrivilege20();
                } 
                this.loadingModal.hide();
                return true;
            };
            this.redeemController.onAddToCartError = () => {
                this.loadingModal.hide();
                return true;
            };
        },
        //#endregion event

        onLoadedCampaign: function() {
        },
        
    },
}
</script>
<style lang="scss" scoped>
.logo-powerby {
    width: 166px;
}
.footer-mobile-witdh {
   width: calc(100% - 28px) ;
}
.contents-height{
    min-height: calc(50vh);
}
</style>
